//@flow

import type {PlayerData, ScheduledEpisode, Show, Season, PlayerContainer, VideoData, VideoList} from '../store';

export const CHANGE_SUBNAV = 'CHANGE_SUBNAV';
export const CHANGE_SUBNAV_MORE = 'CHANGE_SUBNAV_MORE';

export const CLICK_DESCRIPTION_MORE = 'CLICK_DESCRIPTION_MORE';
export const CLICK_DESCRIPTION_CLOSE = 'CLICK_DESCRIPTION_CLOSE';

export const CLICK_PREVIEW_ON = 'CLICK_PREVIEW_ON';
export const CLICK_PREVIEW_OFF = 'CLICK_PREVIEW_OFF';
export const PREVIEW_VIDEO_END = 'PREVIEW_VIDEO_END';

export const CLICK_CLIPS_ON = 'CLICK_CLIPS_ON';
export const CLICK_CLIPS_OFF = 'CLICK_CLIPS_OFF';
export const CLICK_CLIP_L_ARROW = 'CLICK_CLIP_L_ARROW';
export const CLICK_CLIP_R_ARROW = 'CLICK_CLIP_R_ARROW';
export const CLIP_CHANGE_PAGE = 'CLIP_CHANGE_PAGE';
export const CLIP_CHANGE_PAGE_SIZE = 'CLIP_CHANGE_PAGE_SIZE';
export const CLIP_VIDEO_END = 'CLIP_VIDEO_END';

export const LOAD_VIDEO = 'LOAD_VIDEO';

export const LOAD_LIVESTREAM = 'LOAD_LIVESTREAM';

export const SHARE_FACEBOOK = 'SHARE_FACEBOOK';
export const SHARE_TWITTER = 'SHARE_TWITTER';
export const SHARE_EMAIL = 'SHARE_EMAIL';
export const SHARE_EMBED = 'SHARE_EMBED';

export const CLICK_ON_VIDEO = 'CLICK_ON_VIDEO';
export const CHANGE_SEASON = 'CHANGE_SEASON';
export const CLICK_CHANGE_SPECIAL = 'CLICK_CHANGE_SPECIAL';
export const CLICK_SHOW_ALL_AIRDATES = 'CLICK_SHOW_ALL_AIRDATES';
export const RECEIVED_SCHEDULED_EPISODES = 'RECEIVED_SCHEDULED_EPISODES';

export const AUTOPLAY_TIMER_TICK = 'AUTOPLAY_TIMER_TICK';
export const AUTOPLAY_CANCEL = 'AUTOPLAY_CANCEL';
export const CLOSE_END_SCREEN = 'CLOSE_END_SCREEN';

export const VIDEO_END = 'VIDEO_END';
export const PLAYER_PLAY = 'PLAYER_PLAY';
export const PLAYER_SEEK = 'PLAYER_SEEK';
export const PLAYER_STOP = 'PLAYER_STOP';
export const PLAYER_PAUSE = 'PLAYER_PAUSE';
export const SET_POSITION = 'SET_POSITION';

export const RECEIVED_SHOW_DATA = 'RECEIVED_SHOW_DATA';
export const FETCHING_SHOW_DATA = 'FETCHING_SHOW_DATA';
export const FETCHING_SHOW_DATA_ERROR = 'FETCHING_SHOW_DATA_ERROR';
export const RECEIVED_VIDEO_LIST = 'RECEIVED_VIDEO_LIST';
export const FETCHING_VIDEO_LIST = 'FETCHING_VIDEO_LIST';
export const FETCHING_VIDEO_LIST_ERROR = 'FETCHING_VIDEO_LIST_ERROR';
export const RECEIVED_VIDEO_DATA = 'RECEIVED_VIDEO_DATA';
export const FETCHING_VIDEO_DATA = 'FETCHING_VIDEO_DATA';
export const FETCHING_VIDEO_DATA_ERROR = 'FETCHING_VIDEO_DATA_ERROR';
export const RECEIVED_CLIPS_DATA = 'RECEIVED_CLIPS_DATA';
export const FETCHING_CLIPS_DATA = 'FETCHING_CLIPS_DATA';
export const FETCHING_CLIPS_DATA_ERROR = 'FETCHING_CLIPS_DATA_ERROR';

declare type ActionT<A: string, P> = {|
  type: A,
  payload: P,
|};

export type Action =
  | ActionT<'CHANGE_SUBNAV', string>
  | ActionT<'CHANGE_SUBNAV_MORE', string>
  | ActionT<'CLICK_DESCRIPTION_MORE', null>
  | ActionT<'CLICK_DESCRIPTION_CLOSE', null>

  | ActionT<'CLICK_CLIPS_ON', null>
  | ActionT<'CLICK_CLIPS_OFF', null>
  | ActionT<'CLICK_CLIP_L_ARROW', null>
  | ActionT<'CLICK_CLIP_R_ARROW', null>
  | ActionT<'CLIP_CHANGE_PAGE', number>
  | ActionT<'CLIP_CHANGE_PAGE_SIZE', number>
  | ActionT<'CLIP_VIDEO_END', string>

  | ActionT<'LOAD_VIDEO', PlayerData>

  | ActionT<'LOAD_LIVESTREAM', boolean>

  | ActionT<'SET_POSITION', number>

  | ActionT<'CLICK_PREVIEW_ON', null>
  | ActionT<'CLICK_PREVIEW_OFF', null>
  | ActionT<'PREVIEW_VIDEO_END', string>

  | ActionT<'SHARE_FACEBOOK', null>
  | ActionT<'SHARE_TWITTER', null>
  | ActionT<'SHARE_EMAIL', null>
  | ActionT<'SHARE_EMBED', null>

  | ActionT<'AUTOPLAY_CANCEL', null>
  | ActionT<'AUTOPLAY_TIMER_TICK', null>
  | ActionT<'CLOSE_END_SCREEN', null>

  | ActionT<'CLICK_ON_VIDEO', null>
  | ActionT<'PLAYER_SEEK', null>
  | ActionT<'PLAYER_STOP', null>
  | ActionT<'PLAYER_PAUSE', null>
  | ActionT<'PLAYER_PLAY', null>
  | ActionT<'VIDEO_END', PlayerContainer>

  | ActionT<'CHANGE_SEASON', Season>
  | ActionT<'CLICK_CHANGE_SPECIAL', number>
  | ActionT<'CLICK_SHOW_ALL_AIRDATES', boolean>
  | ActionT<'RECEIVED_SCHEDULED_EPISODES', Array<ScheduledEpisode>>

  | ActionT<'RECEIVED_VIDEO_LIST', VideoList>
  | ActionT<'FETCHING_VIDEO_LIST', null>
  | ActionT<'FETCHING_VIDEO_LIST_ERROR', Error|null>

  | ActionT<'RECEIVED_VIDEO_DATA', PlayerContainer>
  | ActionT<'FETCHING_VIDEO_DATA', null>
  | ActionT<'FETCHING_VIDEO_DATA_ERROR', Error|null>

  | ActionT<'RECEIVED_SHOW_DATA', Show>
  | ActionT<'FETCHING_SHOW_DATA', null>
  | ActionT<'FETCHING_SHOW_DATA_ERROR', Error|null>

  | ActionT<'RECEIVED_CLIPS_DATA', Array<VideoData>>
  | ActionT<'FETCHING_CLIPS_DATA', null>
  | ActionT<'FETCHING_CLIPS_DATA_ERROR', Error|null>;
